import React from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';

const languageOptions = [
  { key: 'ar', value: 'ar', flag: 'ps', text: 'العربية', link: '/ar-lang' },
  { key: 'tr', value: 'tr', flag: 'tr', text: 'Türkçe', link: '/tr-lang' },
  { key: 'en', value: 'en', flag: 'us', text: 'English', link: '/en-lang' },
  { key: 'de', value: 'de', flag: 'de', text: 'Deutsch', link: '/de-lang' },
  { key: 'es', value: 'es', flag: 'es', text: 'Español', link: '/es-lang' },
  { key: 'fr', value: 'fr', flag: 'fr', text: 'Français', link: '/fr-lang' },
  { key: 'mx', value: 'mx', flag: 'mx', text: 'Español Mexicano', link: '/mx-lang' },
];

const LanguageSelector = ({
  onLanguageChange,
  currentLanguage
}) => {
  const handleChange = (e, { value }) => {
    const language = languageOptions.find(lang => lang.value === value);
    if (language && onLanguageChange) {
      onLanguageChange(language);
    }
  };

  return (
    <div className="language-selector" style={{ position: 'relative', paddingLeft: '15px', paddingTop: '14px' }}>
      <Dropdown
        icon={null}
        trigger={(
          <div 
            className="language-trigger" 
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '2px', 
              color: 'white',
              padding: '4px 8px',
              cursor: 'pointer',
              borderRadius: '4px',
              height: '40px'
            }}
          >
            <Icon name="world" style={{ margin: 0 }} />
            <Icon name="dropdown" style={{ margin: 0 }} />
          </div>
        )}
        floating
        options={languageOptions}        
        onChange={handleChange}
        value={currentLanguage}
        pointing="top right"
        direction="left"
        style={{ zIndex: 9999, color: 'white' }}
        className="language-dropdown"
        onClick={(e) => e.stopPropagation()}
      />
      <style>{`
        .ui.dropdown.language-dropdown {
          display: inline-block;
        }
        .ui.dropdown.language-dropdown .menu {
          z-index: 9999 !important;
        }
        .language-trigger:hover {
          background-color: rgba(255, 255, 255, 0.1);
        }
      `}</style>
    </div>
  );
};

export default LanguageSelector;
